import { createAsyncThunk } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { ApiCall } from '../../helper/axios';

export const contactUsAsync = createAsyncThunk('fetch/contactUs', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', '/contact-support', param.payload, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        param.callback(res.data.success, res.data.message);
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});